import {
  BellRing,
  Box,
  CircleGauge,
  FileChartColumn,
  FileCog,
  FileStack,
  Globe,
  Mails,
  QrCode,
  ReceiptText,
  Store,
  UserRound,
  UsersRound,
} from 'lucide-react';

// ? ============================= Super Admin Menus ============================= ?
const superadminMenuItems = [
  {
    title: 'Dashboard',
    url: '/superadmin/dashboard',
    icon: CircleGauge,
    roles: ['SUPERADMIN'],
  },
  {
    title: 'Owner Management',
    url: '/superadmin/owner-management',
    icon: UsersRound,
    roles: ['SUPERADMIN'],
  },
  {
    title: 'Store Management',
    url: '/superadmin/store-management',
    icon: Store,
    roles: ['SUPERADMIN'],
  },
  {
    title: 'Vendor Management',
    url: '/superadmin/vendor-management',
    icon: Box,
    roles: ['SUPERADMIN'],
  },
  {
    title: 'Alerts',
    url: '/superadmin/alerts',
    icon: BellRing,
    roles: ['SUPERADMIN'],
  },
  {
    title: 'Genie Requests',
    url: '/superadmin/genie-requests',
    icon: Mails,
    roles: ['SUPERADMIN'],
  },
  {
    title: 'Uploaded Files',
    url: '/superadmin/uploaded-files',
    icon: FileStack,
    roles: ['SUPERADMIN'],
  },
];

// ? ============================= Store Owner Menus ============================= ?
const storeOwnerMenuItems = [
  {
    title: 'Dashboard',
    url: '/owner/dashboard',
    icon: CircleGauge,
    roles: ['OWNER'],
  },
  {
    title: 'Employee Management',
    url: '/owner/employee-management',
    icon: UserRound,
    roles: ['OWNER'],
  },
  {
    title: 'QR Code Settings',
    url: '/owner/qr-code-generator/settings',
    icon: FileCog,
    roles: ['OWNER'],
  },
  {
    title: 'Landing Page',
    url: '/owner/landing-page-configuration',
    icon: Globe,
    roles: ['OWNER'],
  },
  {
    title: 'Vendors',
    url: '/owner/vendors',
    icon: Box,
    roles: ['OWNER'],
  },
  {
    title: 'Print QR Codes',
    url: '/owner/print-qr',
    icon: QrCode,
    roles: ['OWNER'],
  },
  {
    title: 'Leads',
    url: '/owner/quote-and-lead',
    icon: ReceiptText,
    roles: ['OWNER'],
  },
  {
    title: 'Reports',
    url: '/owner/reports',
    icon: FileChartColumn,
    roles: ['OWNER'],
  },
];

// ? ============================= Manager Menus ============================= ?
const managerMenuItems = [
  {
    title: 'Dashboard',
    url: '/manager/dashboard',
    icon: CircleGauge,
    roles: ['MANAGER'],
  },
  {
    title: 'Employee Management',
    url: '/manager/employee-management',
    icon: UserRound,
    roles: ['MANAGER'],
  },
  {
    title: 'QR Code Settings',
    url: '/manager/qr-code-generator/settings',
    icon: FileCog,
    roles: ['MANAGER'],
  },
  {
    title: 'Landing Page',
    url: '/manager/landing-page-configuration',
    icon: Globe,
    roles: ['MANAGER'],
  },
  {
    title: 'Vendors',
    url: '/manager/vendors',
    icon: Box,
    roles: ['MANAGER'],
  },
  {
    title: 'Print QR Codes',
    url: '/manager/print-qr',
    icon: QrCode,
    roles: ['MANAGER'],
  },
  {
    title: 'Leads',
    url: '/manager/quote-and-lead',
    icon: ReceiptText,
    roles: ['MANAGER'],
  },
  {
    title: 'Reports',
    url: '/manager/reports',
    icon: FileChartColumn,
    roles: ['MANAGER'],
  },
];

// ? ============================= Employee Menus ============================= ?
const employeeMenuItems = [
  {
    title: 'Dashboard',
    url: '/employee/dashboard',
    icon: CircleGauge,
    roles: ['EMPLOYEE'],
  },
  {
    title: 'Vendors',
    url: '/employee/product-lookup',
    icon: Box,
    roles: ['EMPLOYEE'],
  },
  {
    title: 'Reports',
    url: '/employee/reports',
    icon: FileChartColumn,
    roles: ['EMPLOYEE'],
  },
  // {
  //   title: 'QR Codes',
  //   url: '/employee/print-qr',
  //   icon: QrCode,
  //   roles: ['EMPLOYEE'],
  // },
];

// ? ============================= All Menus ============================= ?
export const menuItems = [
  ...superadminMenuItems,
  ...storeOwnerMenuItems,
  ...managerMenuItems,
  ...employeeMenuItems,
];
